/**
 * Read a free-text section from a report by its (string-typed) key.
 * Returns the empty string when the section is missing or — defensively —
 * when the underlying value is not a string. Use this at sites that pull
 * a key out of a `ReportSectionConfig` (whose `key` field is `string`)
 * and need a guaranteed-string back for `.trim()` / rendering.
 */
export function getReportSectionText(content, key) {
    if (!content)
        return '';
    const value = content[key];
    return typeof value === 'string' ? value : '';
}
/**
 * Reserved section key: a template section with this key positions the
 * structured clinical-tags chip field instead of a free-text area. The editors
 * render DiagnosesField there; the PDF generator skips it in the sections
 * block (the printed tags line stays governed by the layout's showDiagnoses).
 * Templates WITHOUT this section hide the field unless the report already
 * carries tags.
 */
export const CLINICAL_TAGS_SECTION_KEY = 'clinicalTags';
